<template>
  <div class="tabs_content" v-show="$_loggedUser_action_allowed('services')">
    <section>
      <service-channels-popup
          v-if="serviceChannelsPopupData"
          :popup-data="serviceChannelsPopupData"
          :show-channel-sort="true"
          @close="serviceChannelsPopupData = null"
      />
      <service-info-popup
          v-if="serviceInfoPopupData"
          :service="serviceInfoPopupData"
          @close="serviceInfoPopupData = null"
      />
      <service-validity-popup
          v-if="serviceValidityPopupData"
          :popup-data="serviceValidityPopupData"
          @close="serviceValidityPopupData = null"
          @save="updateSubscriberServices"
      />
      <available-services-list
          v-if="showAvailableServices"
          :services="availableServices"
          :allowedVodPackagesIds="allowedVodPackagesIds"
          :all-device-groups="allDeviceGroups"
          :device-group-channels-restriction="deviceGroupChannelsRestriction"
          :all-channels="allChannels"
          @close="showAvailableServices = false"
          @add="addSubscriberServices"
      />
      <ServiceAdvertisementPopup
          v-if="serviceAdvertisementPopupData"
          :data="serviceAdvertisementPopupData"
          :channel-list="allChannels"
          @close="serviceAdvertisementPopupData = null"
      />
      <div class="final_service">

        <div class="final_service_header">
          <h2 v-translate>Výsledná služba</h2>

          <div class="final_service_header_status">
            <p class="field">
              <select-box
                  id="service_final_date"
                  :omit-label="true"
                  v-model="finalDateRangeFilter"
                  :options="serviceIntervalsOptions"
              />
            </p>
            <a @click="showAvailableServices = true" class="add add_expand" :title="$gettext('Přidat služby')"
               v-translate>Přidat služby</a>
          </div>
        </div>
        <services-icons
            v-if="summed.hasOwnProperty('all_channels_ids')"
            :service-type="'final'"
            :service-data="finalServiceData"
            :allowedVodPackagesIds="allowedVodPackagesIds"
            @showChannels="finalServiceShowChannels"
            @showAdvertisementPopup="onShowAdvertisementPopup"
        />
      </div>

      <div class="assigned_services">
        <div class="assigned_services_header">
          <h2 v-translate>Přiřazené služby</h2>
          <search-input
              :show-label="false"
              p-class="field search-field"
              input-class="search clearable"
              :input-placeholder="'Vyhledat službu' | translate"
              v-model="search"
              ref="searchavailableserviceref"
          />
        </div>
        <service-filter-by-property
            ref="serviceFilterByPropertyRef"
            :show-pack-button="false"
            v-model="propertyFilter"
        />
        <div class="service_list">
          <div :class="['service_item', {disabled: !isServiceActive(service)}]"
               v-for="service in filteredServices"
               :key="'item-'+service.id"
          >
            <div class="service_header">
              <div class="service_name">
                <a
                    v-if="$_loggedUser_action_allowed('services', 'read')"
                    class="service_info"
                    :title="$gettext('Info o službě')"
                    @click="onServiceInfoTableClick(service)"
                    v-translate>Info
                </a>
                <span v-if="!service.assignable" class="archive" :title="$gettext('Archivováno')" v-translate>Archivováno</span>
                <h3><a @click="onServiceInfoClick(service.id)">{{ service.name }}</a></h3>
              </div>
              <div class="service_header_status">
                <p class="service_validity">
                  <a
                      class="btn btn_action btn_close"
                      title="Zrušit platnost"
                      v-if="hasSubscriberServiceValidity(service) && isEditable"
                      @click="removeSubscriberServiceValidity(service)"
                      v-translate>Zrušit platnost</a>
                  <span v-if="hasAnyValidity(service)" :class="{help: hasDifferentFinalDates(service)}">
															<span :class="{dotted: hasDifferentFinalDates(service)}">
                                {{ serviceValidity(service) }}
                              </span>
															<span v-if="hasDifferentFinalDates(service)" class="help_popup">
																<span v-translate>Operátorská platnost</span>
                                {{ helperServiceValidity(service) }}<br />
																<span v-translate>Platnost odběratele</span>
                                {{ helperSubscriberServiceValidity(service) }}<br />
																<span v-translate>Výsledná platnost</span>
                                {{ helperFinalValidity(service) }}
                              </span>
														</span>
                  <a
                      v-if="isEditable"
                      class="btn btn_action service_validity_edit"
                      :title="'Upravit platnost' | translate"
                      @click.stop.prevent="validityIconClicked(service)"
                      v-translate>Upravit platnost
                  </a>
                </p>
                <a v-if="isEditable"
                   class="btn btn_action btn_delete"
                   :title="$gettext('Odebrat službu')"
                   @click.stop.prevent="deleteSubscriberService(service.id)"
                   v-translate>Smazat
                </a>
              </div>
            </div>
            <services-icons
                :service-type="'assigned'"
                :service-data=getServiceData(service)
                :allowedVodPackagesIds="allowedVodPackagesIds"
                @showChannels="showAssignedServiceChannels(service.id)"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ServicesIcons from "./ServicesIcons.vue"
import ServiceChannelsPopup from "./ServiceChannelsPopup.vue"
import ServiceInfoPopup from "./ServiceInfoPopup.vue"
import ServiceValidityPopup from "./ServiceValidityPopup.vue"
import AvailableServicesList from "./AvailableServicesList.vue"
import subscriberService from "../mixins/subscriberService"
import serviceFilterByProperty from "./ServiceFilterByProperty.vue"
import ServiceAdvertisementPopup from "./ServiceAdvertisementPopup.vue"
import listActions from "../../../mixins/list-actions"
import subscribers from "@/components/views/subscribers/mixins/subscribers"
import detailActions from "@/components/mixins/detail-actions"

export default {
  name: "SubscriberDetailServices",
  components: {
    ServiceAdvertisementPopup,
    ServicesIcons,
    ServiceChannelsPopup,
    ServiceInfoPopup,
    ServiceValidityPopup,
    AvailableServicesList,
    serviceFilterByProperty,
  },
  mixins: [detailActions, listActions, subscribers, subscriberService],
  props: {
    entity: Object,
    isEditable: Boolean,
  },
  data() {
    return {
      allServices: [],
      allChannels: [],
      allDeviceGroups: [],
      deviceGroupChannelsRestriction: [],
      allowedVodPackagesIds: [],
      serviceIntervalsOptions: [],
      summed: [],

      showAssignedServices: false,
      intervalSelected: null,
      serviceChannelsPopupData: null,
      serviceInfoPopupData: null,
      serviceValidityPopupData: null,
      showAvailableServices: false,
      serviceAdvertisementPopupData: null,
    }
  },
  created(SubscriberService, ServiceService) {
    this.entityService = SubscriberService
    this.serviceService = ServiceService
    this.getSubscriberServices(this.getDefaultByModuleName('subscriberServices', 'sort'))
    this.getSubscriberFinalServiceByInterval()
    this.entityService.getOperatorChannels(this.entity.id).then((data) => {
      this.allChannels = data['all_channels']
    })
    this.entityService.getDeviceGroups(this.entity.id).then((data) => {
      this.allDeviceGroups = data['all_device_groups']
      this.deviceGroupChannelsRestriction = data['device_group_channels_restriction']
    })
  },
  computed: {
    services() {
      let assigned = {
        ...this._.filter(this.allServices, function (service) {
          return service.checked
        })
      }

      return this._.sortBy(assigned, function (service) {
        return service.name
      })
    },
    availableServices() {
      return this._.filter(this.allServices, function (service) {
        return !service.checked
      })
    },

    finalServiceData() {
      return this.getServiceData(this.summed);
    },
    finalDateRangeFilter: {
      get() {
        if (this.intervalSelected !== null && this.isValueInOptionsFound) {
          return this.intervalSelected
        }
        return this.currentInterval
      },
      set(newValue) {
        this.intervalSelected = newValue
        this.getSubscriberFinalServiceByInterval(newValue)
      }
    },
    isValueInOptionsFound() {
      let found = false
      this._.forEach(this.serviceIntervalsOptions, function (item) {
        if (this.intervalSelected === item['id']) {
          found = true
        }
      }.bind(this))
      return found
    },
    currentInterval() {
      let currentValue = ''
      let currentTimestamp = Math.floor(Date.now() / 1000);
      if (this.serviceIntervalsOptions.length) {
        this._.forEach(this.serviceIntervalsOptions, function (interval) {
          let splitValues = this._.split(interval['id'], '-')
          let fromValue = Number(splitValues[0])
          let toValue = Number(splitValues[1])
          if ((fromValue < currentTimestamp || fromValue === 0) &&
              (toValue > currentTimestamp || toValue === 0)
          ) {
            currentValue = interval['id']
          }
        }.bind(this))
        if (currentValue === '') {
          return this.serviceIntervalsOptions[0]['id']
        }
      }
      return currentValue
    },
  },
  methods: {
    getSubscriberServices(params) {
      this.entityService.getSubscriberServices(this.entity['id'], { sort: params })
          .then(response => {
            this.allServices = response['services']
            this.allowedVodPackagesIds = response['allowed_vod_packages_ids']
          })
    },
    getSubscriberFinalServiceByInterval(interval = null) {
      let params = null
      if (interval !== null) {
        let splitValues = this._.split(interval, '-')
        // always send "from" except when "from" is null/zero/unlimited, in such case send "to"
        let timestamp = Number(splitValues[0]) === 0 ? Number(splitValues[1]) : Number(splitValues[0])
        params = { 'timestamp': timestamp }
      }

      this.setLoadingMessage()
      this.entityService.getSubscriberServiceIntervals(this.entity.id, params)
          .then(data => {
            this.emptyMessage()
            this.summed = data['summed']
            this.serviceIntervalsOptions = data['service_intervals_options'].map(item => {
              let newText = item.text;

              if (newText.includes("neomezeně")) {
                newText = newText.replace(/neomezeně/g, this.$gettext("neomezeně"));
              }

              return {
                ...item,
                text: newText
              };
            });
          })
          .catch((error) => {
            this.setErrorMessage(error['error_message'])
          })
    },
    addSubscriberServices(ids) {
      this.showAvailableServices = false
      this.callUpdateSubscriberServicesMethod(this.getAddSubscriberServicesParams(ids))
    },
    updateSubscriberServices(data) {
      this.callUpdateSubscriberServicesMethod(this.getUpdateSubscriberServicesParams(data))
    },
    deleteSubscriberService(id, showPopup = true) {
      if (showPopup) {
        this.showPopup(id, 'delete', 'delete-service')
      } else {
        this.callUpdateSubscriberServicesMethod(this.getDeleteSubscriberServicesParams(id))
      }
    },
    callUpdateSubscriberServicesMethod(params) {
      this.entityService.updateSubscriberServices(this.entity.id, params)
          .then(() => {
            this.setSuccessMessage()
            this.getSubscriberServices()
            this.getSubscriberFinalServiceByInterval()
          })
          .catch(function (error) {
            this.setErrorMessage(this.processSubscriberServiceErrorMessage(error))
          }.bind(this))
    },
    getAddSubscriberServicesParams(ids) {
      let create = {}
      this._.assign(create, { 'ids': ids })

      return { 'create': create }
    },
    getUpdateSubscriberServicesParams(data) {
      let update = {}
      this._.assign(update, this.getSubscriberServicesParamsByAction(data, 'update'))
      return { 'update': update }
    },
    getDeleteSubscriberServicesParams(id) {
      let remove = {}
      this._.assign(remove, this.getSubscriberServicesParamsByAction({ 'id': id }, 'delete'))
      return { 'delete': remove }
    },
    getSubscriberServicesParamsByAction(data, action) {
      let params = {}
      let serviceId = data['id']
      if (action === 'update') {
        params[serviceId] = {
          'id': serviceId,
          'active_from': this.$_date_toMysqlFormatFromString(data['active_from']),
          'active_to': this.$_date_toMysqlFormatFromString(data['active_to']),
        }
      } else {
        params[serviceId] = { 'id': serviceId }
      }
      return params
    },

    finalServiceShowChannels() {
      this.loadServiceChannelsPopupData(this.summed['all_channels_ids'], this.summed['channels_summed'])
    },
    onShowAdvertisementPopup(data) {
      this.serviceAdvertisementPopupData = data;
    },
    showAssignedServiceChannels(serviceId) {
      let service = this.getServiceByServiceId(this.allServices, serviceId)
      this.loadServiceChannelsPopupData(service['id_channels_including_from_channel_packages'], service['summed'])
    },
    getServiceByServiceId(services, serviceId) {
      let service = this._.filter(services, function (assignedService) {
        return Number(serviceId) === Number(assignedService.id)
      })
      if (service) {
        return service[0]
      }
      return {}
    },
    onServiceInfoTableClick(service) {
      this.serviceInfoPopupData = {
        'date_assigned': service.date_assigned,
        'user_assigned': service.user_assigned,
        'date_updated': service.date_updated,
        'user_updated': service.user_updated
      }
    },
    hasDifferentFinalDates(service) {
      return (
          service.subscriber_active_from !== null &&
          service.subscriber_active_from !== service.valid_from &&
          service.valid_from !== null
      ) || (
          service.subscriber_active_to !== null &&
          service.subscriber_active_to !== service.valid_to &&
          service.valid_to !== null
      )
    },
    hasSubscriberServiceValidity(service) {
      return service.subscriber_active_from != null || service.subscriber_active_to
    },
    hasAnyValidity(service) {
      return service.final_active_from != null || service.final_active_to;
    },
    helperServiceValidity(service) {
      return this.composeValidity(service.valid_from, service.valid_to)
    },
    helperSubscriberServiceValidity(service) {
      return this.composeValidity(service.subscriber_active_from, service.subscriber_active_to)
    },
    helperFinalValidity(service) {
      return this.composeValidity(service.final_active_from, service.final_active_to)
    },
    composeValidity(fromValue, toValue) {
      fromValue = fromValue === null ? this.$gettext('neomezeně') : fromValue
      toValue = toValue === null ? this.$gettext('neomezeně') : toValue
      return fromValue + '\xa0-\xa0' + toValue
    },
    serviceValidity(service) {
      let validity = ''
      let finalActiveFrom = service.final_active_from
      let finalActiveTo = service.final_active_to
      if (finalActiveFrom) {
        validity += this.$gettext('Platnost od') + " " + finalActiveFrom
        if (finalActiveTo) {
          validity += ' – ' + finalActiveTo
        }
        return validity
      }
      if (finalActiveTo) {
        validity += this.$gettext('Platnost do') + " " + finalActiveTo
        return validity
      }
      return validity
    },
    validityIconClicked(service) {
      this.serviceValidityPopupData = {
        'id': service.id,
        'active_from': service.subscriber_active_from,
        'active_to': service.subscriber_active_to
      };
    },
    removeSubscriberServiceValidity(service) {
      this.updateSubscriberServices({
        'id': service.id,
        'active_from': null,
        'active_to': null
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/servicesList/ServicesList.vue